
    import Vue from "vue";
    import ApiButton from "@/components/ApiButton.vue";
    import Component from "vue-class-component";
    import * as toastr from "toastr";
    import { BookingAllocation } from "@/model/BookingAllocation";
    import { ApiClient } from "@/utilities/ApiClient";
    import { Prop } from "vue-property-decorator";

    
    @Component({
        components: { 
            ApiButton
        }
    })

    export default class AllocationCheckInTimeModal extends Vue {

        //
        // -- properties
        //

        private allocation = new BookingAllocation();
        private employeeName: string = "";
        private timeOptions: Array<string> = ["00:00", "00:30", "01:00", "01:30", "02:00", "02:30",
            "03:00", "03:30", "04:00", "04:30", "05:00", "05:30", "06:00", "06:30", "07:00", "07:30",
            "08:00", "08:30", "09:00", "09:30", "10:00", "10:30", "11:00", "11:30", "12:00", "12:30",
            "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30",
            "18:00", "18:30", "19:00", "19:30", "20:00", "20:30", "21:00", "21:30", "22:00", "22:30",
            "23:00", "23:30"];

        //
        // -- methods
        //

        show(allocationID: number, employeeName: string) {
            this.employeeName = employeeName;
            this.loadAllocation(allocationID);
        }

        async loadAllocation(id: number) {
            const response = await ApiClient.get(`/Api/Booking/Allocation?id=${id}`)
            this.allocation.update(response);
            this.$bvModal.show("allocationCheckInTimeModal");
        }

        cancel() {
            this.$bvModal.hide("allocationCheckInTimeModal");
        }

        async save(event: Event) {
            await ApiClient.post("/Api/Booking/AllocationCheckInTimeSave", this.allocation, event);
            toastr.success("Saved");
            this.$emit("loadAllocationsDetail");
            this.$bvModal.hide("allocationCheckInTimeModal");
        }
    }

